module.exports = "/_next/static/images/bank-bni-icon-dab72518cca9ef73590a1b55bafeeba0.svg";